import { render, staticRenderFns } from "./PeppolContactRegistrationStatus.vue?vue&type=template&id=4776d931&scoped=true"
import script from "./PeppolContactRegistrationStatus.vue?vue&type=script&lang=ts"
export * from "./PeppolContactRegistrationStatus.vue?vue&type=script&lang=ts"
import style0 from "./PeppolContactRegistrationStatus.vue?vue&type=style&index=0&id=4776d931&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4776d931",
  null
  
)

export default component.exports